import React from 'react';

// helpers
import { styled } from 'styled-components';
import { EntityIntakeFormContextProvider } from 'modules/IntakeForm/EntityIntakeForm/EntityIntakeFormContext';

// components
import EntityIntakeForm from 'modules/IntakeForm/EntityIntakeForm';

const IntakeFormPage = () => {
  return (
    <EntityIntakeFormContextProvider>
      <ContentWrapper>
        <EntityIntakeForm />
      </ContentWrapper>
    </EntityIntakeFormContextProvider>
  );
};

const ContentWrapper = styled.div`
  padding-top: 64px;
  width: 75%;
  margin: 0 auto;

  @media screen and (max-width: ${({ theme }) => theme.hdScreen}) {
    width: 80%;
    max-width: 80%;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletScreen}) {
    width: 100%;
    max-width: 100%;
  }
`;

export default IntakeFormPage;
